export type AppRoute = 'home' | 'support' | 'ios-privacy';

export function normalizePath(pathname: string): string {
  return (pathname.replace(/\/+$/, '') || '/').toLowerCase();
}

export function getAppRoute(pathname: string): AppRoute {
  const normalizedPath = normalizePath(pathname);
  if (normalizedPath === '/support') {
    return 'support';
  }

  if (normalizedPath === '/ios-privacy') {
    return 'ios-privacy';
  }

  return 'home';
}

export function isSupportRoute(route: AppRoute): boolean {
  return route === 'support';
}

export function isIosPrivacyRoute(route: AppRoute): boolean {
  return route === 'ios-privacy';
}
